export const NOT_AVAILABLE = 'N/A'
export const UNKNOWN = 'Unknown'
export const NONE = 'None'
